import { CustomConfigurationTreeItemLabel } from "./ConfigurationTreeItemLabel";
import { ConfigurationTreeItemUi } from "./ConfigurationTreeItemUi";
import { CustomConfigurationTreeCompleteness } from "./CustomConfigurationTreeCompleteness";

export const CustomConfigurationTreeComponents = {
  /**
   * The UI component for a tree item.
   * ⚠️ MUST use `@mui/x-tree-view` mechanism
   * - components TreeItem or TreeItem2
   * - hooks useTreeItem or useTreeItem2
   */
  ConfigurationTreeItemUi,
  /**
   * The label component for a tree item.
   */
  ConfigurationTreeItemLabel: CustomConfigurationTreeItemLabel,
  /**
   * The completeness component for a tree item.
   */
  ConfigurationTreeCompleteness: CustomConfigurationTreeCompleteness,
};

export type CustomConfigurationTreeComponentsMapping =
  typeof CustomConfigurationTreeComponents;
